"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _classNames = _interopRequireDefault(require("react-utils/classNames"));

var _ButtonConstants = require("../button/ButtonConstants");

var CARET_CLASS_FOR_USE = {
  form: 'private-dropdown__caret--form',
  'form-on-dark': 'private-dropdown__caret--form',
  'link-on-dark': 'private-dropdown__caret--link-on-dark'
};

var UIDropdownCaret = function UIDropdownCaret(_ref) {
  var className = _ref.className,
      hidden = _ref.hidden,
      use = _ref.use;
  var computedClassName = (0, _classNames.default)(className, 'uiDropdown__buttonCaret', 'private-dropdown__caret', CARET_CLASS_FOR_USE[use], {
    'private-dropdown__caret--hidden': hidden
  });
  return _react.default.createElement("span", {
    className: computedClassName
  });
};

UIDropdownCaret.propTypes = {
  hidden: _react.PropTypes.bool,
  use: _react.PropTypes.oneOf(Object.keys(_ButtonConstants.USE_CLASSES))
};
UIDropdownCaret.displayName = 'UIDropdownCaret';
var _default = UIDropdownCaret;
exports.default = _default;
module.exports = exports.default;